import axios from "axios";
import { config } from "../../Network_Calls/config";

export const getGift = async (token) => {
  try {
    const response = await axios.get(
      process.env.REACT_APP_SERVER_URL + `/create-access-token/${token}`,
      {
        ...config(),
      }
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
